module.exports = __webpack_public_path__ + "static/media/bread.ca7a69e1.png";